import React from 'react';
import { Checkbox, Icon, Button, Input, Select, Modal } from 'antd';
import CitySelect from './CitySelect';
import EditPlace from './EditPlace';
import PropTypes from 'prop-types';
import { cloneDeep } from 'lodash';
import { FormattedMessage as FM, injectIntl } from 'react-intl';

const { Option } = Select;

/**
 * 选择地点组件
 */
class SelectPlace extends React.Component {
  static propTypes = {
    /**
     * 考勤打卡-admin key
     */
    mapKey: PropTypes.string
  };
  static defaultProps = {};

  constructor(props) {
    super(props);
    const { name, address, selectedJobs, expansion, checked } = this.props;
    this.state = {
      expansion,
      checked,
      name,
      address: cloneDeep(address),
      selectedJobs: cloneDeep(selectedJobs)
    };
  }

  componentDidMount = () => {};

  componentWillUnmount = () => {};

  handleDone = () => {
    const { onDone } = this.props;
    const { name, address, selectedJobs } = this.state;
    onDone && onDone({ name, address, selectedJobs });
  };

  handleRadiusChange = radius => {
    this.setState({
      address: {
        ...this.state.address,
        radius
      }
    });
  };

  handleLocationChange = location => {
    this.setState({
      address: {
        ...this.state.address,
        location
      }
    });
  };

  handleCityChange = (value, selectedOptions) => {
    const lastIndex = value.length - 1;
    const cityCode = selectedOptions[lastIndex].v;
    this.setState({
      address: {
        ...this.state.address,
        cities: value,
        cityCode
      }
    });
  };

  handleDelete = () => {
    console.log('handle delete');
    const { onDelete } = this.props;
    Modal.confirm({
      title: '提示',
      content: '您确定要删除吗？',
      onOk: () => onDelete && onDelete()
    });
  };

  renderEdit = () => {
    const { mapKey, jobs, onCheckedChange, fenceSizeMax } = this.props;
    const { name, address, selectedJobs, checked } = this.state;
    const { cities, cityCode, detail, radius, location } = address;

    return (
      <div className="select-place__edit">
        <div className="select-place__edit-wrapper">
          <div className="select-place__edit-index">1</div>
          <div className="select-place__edit-1-content">
            <div className="select-place__edit-1-left">
              <Checkbox
                className="select-place__edit-1-checkbox"
                checked={checked}
                onChange={e => {
                  this.setState({
                    checked: e.target.checked
                  });
                  onCheckedChange && onCheckedChange(e.target.checked);
                }}
              ></Checkbox>
              <Input
                className="select-place__edit-1-name"
                value={name}
                onChange={e => this.setState({ name: e.target.value })}
                placeholder={this.props.intl.formatMessage({
                  id: 'ClockInPlace.addressName'
                })}
              ></Input>
            </div>
            <div className="select-place__edit-1-right">
              <Icon
                type="delete"
                style={{ cursor: 'pointer' }}
                onClick={this.handleDelete}
              />
              <Button
                type="primary"
                shape="round"
                className="select-place__edit-1-done"
                onClick={this.handleDone}
              >
                <FM id="ClockInPlace.done" defaultMessage="完成" />
              </Button>
            </div>
          </div>
        </div>

        <div className="select-place__edit-wrapper">
          <div className="select-place__edit-index">2</div>
          <div className="select-place__edit-2-content">
            <div className="select-place__edit-2-city">
              <div className="select-place__site-address">
                <FM id="ClockInPlace.siteAddress" defaultMessage="地点地址" />
              </div>
              <div className="select-place__city-select">
                <CitySelect
                  value={cities}
                  onChange={this.handleCityChange}
                ></CitySelect>
              </div>
              <Input
                value={detail}
                style={{ width: 120, marginLeft: 16 }}
                onChange={e =>
                  this.setState({
                    address: {
                      ...address,
                      detail: e.target.value
                    }
                  })
                }
                placeholder={this.props.intl.formatMessage({
                  id: 'ClockInPlace.addressDetail'
                })}
              ></Input>
            </div>
            <EditPlace
              mapKey={mapKey}
              cityCode={cityCode}
              cityPosition={detail}
              onRadiusChange={this.handleRadiusChange}
              radius={radius}
              location={location}
              onLocationChange={this.handleLocationChange}
              fenceSizeMax={fenceSizeMax}
            ></EditPlace>
          </div>
        </div>

        <div className="select-place__edit-wrapper">
          <div className="select-place__edit-index select-place__edit-index--3">
            3
          </div>
          <div className="select-place__edit-3-content">
            <div className="select-place__edit-3-title">
              <FM id="ClockInPlace.avaliableJobs" defaultMessage="可用的工作" />
            </div>
            <div className="select-place__edit-3-subtitle">
              <FM
                id="ClockInPlace.avaliableJobsTip"
                defaultMessage="确定在此状态下可以使用哪些工作"
              />
            </div>
            <Select
              mode="multiple"
              className="select-place__edit-3-select"
              value={selectedJobs}
              onChange={value => {
                this.setState({
                  selectedJobs: value
                });
              }}
              placeholder={this.props.intl.formatMessage({
                id: 'ClockInPlace.selectJobs'
              })}
            >
              {jobs.map(job => (
                <Option key={job.value} value={job.value}>
                  {job.label}
                </Option>
              ))}
            </Select>
          </div>
        </div>
      </div>
    );
  };

  handleExpansion = () => {
    const { onExpansionChange } = this.props;
    this.setState({
      expansion: true
    });
    onExpansionChange && onExpansionChange(true);
  };

  renderView = () => {
    const { name, onCheckedChange } = this.props;
    const { checked } = this.state;
    return (
      <div className="select-place__view">
        <div className="select-place__view-left">
          <Checkbox
            checked={checked}
            onChange={e => {
              this.setState({
                checked: e.target.checked
              });
              onCheckedChange && onCheckedChange(e.target.checked);
            }}
          ></Checkbox>
          <div className="select-place__view-name">{name}</div>
        </div>
        <div
          className="select-place__view-right"
          onClick={this.handleExpansion}
        >
          <Icon type="down" style={{ cursor: 'pointer' }} />
        </div>
      </div>
    );
  };

  render() {
    const { expansion } = this.state;
    return (
      <div className="select-place">
        {expansion ? this.renderEdit() : this.renderView()}
      </div>
    );
  }
}

export default injectIntl(SelectPlace, { withRef: true });
